import './Menu.css'
import React, { useState } from 'react'
import Sidebar from '../../Components/SideBar/index'
import ScrollToTop from '../../Components/ScrollToTop'
import Index2 from '../../Components/Navbar2/index2'
import Footer from '../../Components/Footer/Footer'
import InfoSection3 from '../../Components/Infosection3/Index3'
import { homeObjOne3 } from '../../Components/Infosection3/Data3'

const MenuMex = () => {
   const [isOpen, setIsOpen] = useState(false)
              
      const toggle = () => {
      setIsOpen(!isOpen)
      }
  return (
    <>
      <ScrollToTop />
      <div className='HeroContainer_menu'>
         <Sidebar isOpen={isOpen} toggle={toggle}/>
        <div className='Hero_menu'>
          <Index2 toggle={toggle}/>
        </div>
      </div>
      <InfoSection3 {...homeObjOne3}/>
      <div className='menu_con'>
        <div className='menu_title'>
          Vår Meny
        </div>
        <div className='pris'>
          För mer info kontakta gärna 
          <br />
          076 413 08 53
          <br />
          cateringbyprestig@gmail.com
        </div>
      </div>
      <br />
      <br /><br />
      <div className='menu'>
        <div className='menu_pic'>
          <div className='grid-container'>
                  <div className='card_con'>
                    <div className='wrapper'>
                      <br /><br />
                        <div className='card_area'>
                          <div className='card'>
                            <div className='meny_title'>
                                PREMIUM TACOS
                            </div><br /><br />
                            <div className='menu_mat'>
                                Pulled beef tacos med chipotle, lime & koriander.
                                <br /><br />
                                Chicken tacos med ancho-chili, lime & färska örter.
                                <br /><br />
                                Crispy fish tacos med kålsallad & lime.
                                <br /><br />
                                Mini tortillas med grillade grönsaker & chipotle.
                            </div>
                            </div>
                            <div className='card'>
                              <div className='meny_title'>
                                GUACAMOLE & SALSABAR
                              </div><br /><br />
                              <div className='menu_mat'>
                                Klassisk guacamole med avokado, lime, koriander & tomat.
                                <br /><br />
                                Mango & chili-salsa.
                                <br /><br />
                                Pico de gallo med tomat, rödlök, lime & koriander.
                                <br /><br />
                                Rostad tomat- & jalapeñosalsa.
                                <br /><br />
                                Salsa verde med tomatillo & koriander.
                                <br /><br />
                                Picklad rödlök.
                                <br /><br />
                                Jalapeños.
                                <br /><br />
                                Lime & färsk koriander.
                              </div> 
                            </div>              
                            <div className='card'>
                              <div className='meny_title'>
                                MEXIKANSKA KALLA DELIKATESSER
                              </div><br /><br />
                            <div className='menu_mat'>
                                Mexikansk majssallad med lime, koriander & chili.
                                <br /><br />
                                Svarta bönor med paprika, majs & färska örter.
                                <br /><br />
                                Coleslaw med lime & chipotle.
                                <br /><br />
                                Rostad sötpotatissallad med lime & koriander.
                                <br /><br />
                                Färsk tomat- & avokadosallad.
                            </div>
                            </div>
                            <div className='card'>
                            <div className='meny_title'>
                              GRILLADE & VARMA SPECIALITETER
                                </div><br /><br />
                                <div className='menu_mat'>
                                    Fajitas de Pollo – marinerad kyckling med paprika & lök.
                                    <br /><br />
                                    Carne Asada – grillat nötkött med lime, vitlök & koriander.
                                    <br /><br />
                                    Mexican Chicken Wings – kryddiga kycklingvingar med lime.
                                    <br /><br />
                                    Quesadillas med ost, paprika & jalapeño.
                                    <br /><br />
                                    Elotes – grillad majs med lime, chili & krämig dressing.
                                    <br /><br />
                                    Kryddat mexikanskt ris.
                                </div>
                                </div>
                                <div className='card'>
                              <div className='meny_title'>
                                   EXTRA LYXIGA TILLBEHÖR
                                </div><br /><br />
                                <div className='menu_mat'>
                                    Queso fundido med smält ost & chili.
                                    <br /><br />
                                    Gräddfil med lime.
                                    <br /><br />
                                    Mexikansk ost.
                                    <br /><br />
                                    Tortillachips.
                                    <br /><br />
                                    Rostade majschips.
                                    <br /><br />
                                    Färska örter & lime.
                                </div>
                                </div>
                                <div className='card'>
                                    <div className='meny_title'>
                                        MEXIKANSKA TILLBEHÖR
                                    </div><br /><br />
                                <div className='menu_mat'>
                                    Mexikanskt ris med tomat & koriander.
                                    <br /><br />
                                    Refried beans.
                                    <br /><br />
                                    Rostad potatis med chili & lime.
                                    <br /><br />
                                    Varmt tortillabröd.
                                </div>
                                </div>
                                <div className='card'>
                                    <div className='meny_title'>
                                        MEXIKANSKA DESSERTER
                                    </div><br /><br />
                                    <div className='menu_mat'>
                                        Churros med kanel & chokladsås.
                                        <br /><br />
                                        Tres Leches-kaka.
                                        <br /><br />
                                        Mini-chokladtacos med färska bär.
                                        <br /><br />
                                        Lime cheesecake.
                                        <br /><br />
                                        Färsk mango & ananas med chili & lime.
                                        <br /><br />
                                    </div>
                                </div>
                  </div>             
                </div>
              </div>
            </div>
          </div>
        </div>
      <Footer />
    </>
  )
}

export default MenuMex